export const GET_INFO_HISTORY = 'GET_INFO_HISTORY';
export const GET_INFO_HISTORY_SUCCESS = 'GET_INFO_HISTORY_SUCCESS';
export const GET_INFO_HISTORY_FAIL = 'GET_INFO_HISTORY_FAIL';
